import BasicList from 'core/modules/components/lists/components/BasicList';
import PropTypes from 'prop-types';
import React from 'react';
import CommentItem from '../CommentItem';

const CommentsList = ({ parentGuid, comments, currentUser, onDelete, onEdit, maxComments, onMarkAsRead, disabled }) => {
  return (
    <div className="comments-list">
      <BasicList
        items={comments.map((item) => (
          <CommentItem {...item} currentUser={currentUser} onDelete={onDelete} onEdit={onEdit} parentGuid={parentGuid} onMarkAsRead={onMarkAsRead} disabled={disabled} />
        ))}
      />
    </div>
  );
};

CommentsList.propTypes = {
  comments: PropTypes.array,
  currentUser: PropTypes.object,
  disabled: PropTypes.bool,
  maxComments: PropTypes.number,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  onMarkAsRead: PropTypes.func,
  parentGuid: PropTypes.string,
};

CommentsList.defaultProps = {
  comments: [],
  maxComments: false,
};

export default CommentsList;
